import { render, staticRenderFns } from "./HospitalModal.vue?vue&type=template&id=24cb6313&scoped=true"
import script from "./HospitalModal.vue?vue&type=script&lang=js"
export * from "./HospitalModal.vue?vue&type=script&lang=js"
import style0 from "./HospitalModal.vue?vue&type=style&index=0&id=24cb6313&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb6313",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24cb6313')) {
      api.createRecord('24cb6313', component.options)
    } else {
      api.reload('24cb6313', component.options)
    }
    module.hot.accept("./HospitalModal.vue?vue&type=template&id=24cb6313&scoped=true", function () {
      api.rerender('24cb6313', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HospitalModal.vue"
export default component.exports